import type { ContentTypeContainer } from '../content-types-shell-types';

type ContainerChangeHandler = (token: ContentTypeContainer) => void;

const emptyContainer: ContentTypeContainer = {
	key: '',
	name: '',
	iconPath: '',
};

export class ContentTypeContainerService {
	handlers: ContainerChangeHandler[];
	container: ContentTypeContainer;

	constructor() {
		this.handlers = [];
		this.container = emptyContainer;
	}

	dispose() {
		this.handlers = [];
		this.container = emptyContainer;
	}

	/**
	 * A method called on every change in container.
	 * @returns <void> Calls any associated handlers.
	 */
	updateContainer = (container: ContentTypeContainer) => {
		this.container = container;
		this.handlers.forEach((handler) => handler(container));
	};

	/**
	 * A method called on unmounting of a whiteboard frame.
	 * @returns <void> Calls any associated handlers.
	 */
	resetContainer = () => {
		this.container = emptyContainer;
	};

	/**
	 * Setup listeners for container changes.
	 * @description Called everytime the container updates.
	 */
	onContainerChange = (cb: ContainerChangeHandler) => {
		this.handlers.push(cb);
	};

	/**
	 * Setup listeners for container initialisation.
	 * @description Called once on app init.
	 */
	onContainerInit = (cb: ContainerChangeHandler) => {
		cb(this.container);
	};
}

export const containerService = new ContentTypeContainerService();
